<div style="margin-left: 0.8rem">
  <!--<datos-logo-loader [widthInPixel]="25"></datos-logo-loader>-->
  <mat-spinner [color]="'primary'" [diameter]="18"> </mat-spinner>
</div>
